import {Base} from "@/api/Base"

export class LeaveGetRealLeaveDays extends Base {
    path = "leave/getRealLeaveDays"
}